import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  AwsService,
  HelperService,
  LocalStorageService,
  NotificationService,
  UltiService,
  AuthService
} from '__services';
import { CookieService } from 'ngx-cookie-service';
import { UserProfile } from '~/app/core/models';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  showSpinnerLogout = false;
  userProfile: UserProfile;
  userFeatures: any;
  hour = 0;
  minute = 0;
  colon = false;
  currentSelectedTimeZone = +new Date().getTimezoneOffset() * -1;
  selectedMenu = '';
  notifications: any = [];
  clientTimezone = ''

  constructor(
    private awsService: AwsService,
    private helperService: HelperService,
    public notificationService: NotificationService,
    private localStorageService: LocalStorageService,
    private cookieService: CookieService,
    private ultiService: UltiService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.userProfile = this.localStorageService.getUserProfile();
    this.userFeatures = this.localStorageService.getObject('userFeatures');
    this.notificationService.getCounterUnread();
    this.getClientTimezone();

    if (!this.userProfile) {
      this.getUserProfile();
    }
    this.updateTime();
    setInterval(() => {
      this.updateTime();
      this.colon = !this.colon;
    }, 1000);
    this.helperService.hasChangeProfile.subscribe((res) => {
      this.userProfile = JSON.parse(localStorage.getItem('userProfile'));
    });
  }

  getClientTimezone() {
    const offset = new Date().getTimezoneOffset();
    if(offset <= 0) {
      this.clientTimezone = `GMT+${offset/-60}`
    } else {
      this.clientTimezone = `GMT-${offset/60}`
    }
  }

  onClickNotification(): void {
    if (this.selectedMenu === 'notification') {
      return;
    }

    this.notificationService.latestNotification = false;
    this.notificationService.rawNotifications = [];
    this.notificationService.nextToken = null;
    this.notificationService.getNotifications();
  }

  logout(): void {
    if (this.awsService.preventLogout) {
      if (this.ultiService.confirmLeavePage()) {
        this.executeLogout();
      }
    } else {
      this.executeLogout();
    }
  }

  executeLogout(): void {
    this.showSpinnerLogout = true;
    this.cookieService.delete('_switchUser');
    this.authService.logout();
  }

  updateTime(): void {
    const date = new Date();
    this.currentSelectedTimeZone = +date.getTimezoneOffset() * -1;
    this.hour =
      (date.getUTCHours() + Math.floor(this.currentSelectedTimeZone / 60)) % 24;
    this.minute = date.getUTCMinutes() + (this.currentSelectedTimeZone % 60);
  }

  getUserProfile(): void {
    const profile = this.awsService.getUserInfo().subscribe((res) => {
      this.userProfile = res;
      this.userFeatures = res.role.modules;
      this.localStorageService.setObject('userProfile', this.userProfile);
      this.localStorageService.setObject('userFeatures', this.userFeatures);
      profile.unsubscribe();
    });
  }

  selectMenu(menu): void {
    this.selectedMenu = this.selectedMenu !== menu ? menu : '';
    // if (this.selectedMenu !== menu) {
    //   this.selectedMenu = menu;
    // }
  }

  ngOnDestroy(): void {
    this.notificationService.reset();
  }
}
